import { store } from 'src/redux';

export const renderOptionSubType = (isFilter?: boolean) => {
  const { subType } = store.getState().global.masterData;
  // Nếu filter thì có thêm tất cả
  const listOption = isFilter
    ? [
        {
          value: '',
          label: 'Tất cả',
        },
      ]
    : [];
  if (subType && subType.length > 0) {
    subType?.map((item: any) => {
      listOption.push({
        label: item?.name,
        value: item?.description,
      });
    });
  }
  return listOption;
};
